import { render } from "./IconSortUp.vue?vue&type=template&id=1b1a88d3"
import script from "./IconSortUp.vue?vue&type=script&lang=js"
export * from "./IconSortUp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__